var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"site-nav",attrs:{"aria-label":"Main"}},[_c('the-stack',{staticClass:"site-nav__list",attrs:{"tag-name":"ul"}},_vm._l((_vm.shownNavItems),function(siteNavItem){return _c('site-nav-item',{key:siteNavItem.text,attrs:{"site-nav-item":siteNavItem}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }